import { render, staticRenderFns } from "./TabbedSettings.vue?vue&type=template&id=73c96b8c&scoped=true"
import script from "./TabbedSettings.vue?vue&type=script&lang=js"
export * from "./TabbedSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c96b8c",
  null
  
)

export default component.exports